<template>
    <div class="actions">
        <b-button
            variant="outline-primary"
            class="cancel-button"
            size="sm"
            :disabled="isSubmitting"
            @click="$emit('cancel')"
            >{{
                $t('strategy.onepage.advancedOptions.horizons.actions.cancel')
            }}</b-button
        >
        <b-button
            variant="primary"
            size="sm"
            class="save-button"
            :disabled="isSubmitting"
            @click="$emit('submit')"
        >
            <span v-if="isSubmitting">
                <i class="fa fa-spinner fa-spin" />
            </span>
            <span v-if="!isSubmitting">{{
                $t('strategy.onepage.advancedOptions.horizons.actions.save')
            }}</span>
        </b-button>
    </div>
</template>
<script>
export default {
    props: {
        isSubmitting: {
            type: Boolean,
            required: true,
        },
    },
}
</script>
<style lang="scss" scoped>
.actions {
    display: flex;
    justify-content: center;
    width: 100%;

    .cancel-button {
        min-width: 77px;
        margin-right: 12px;
    }

    .save-button {
        min-width: 60px;
    }
}
</style>
